<template src="./ModalUserZaloDetailComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, reactive} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {useAccountStore} from "@/stores/account.js";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import {useSettingFormatFileStore} from "@/stores/settingFormatFile.js";
export default {
  name: 'ModalUserZaloDetailComponent',
  components: {
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  emits: ['showModal'],
  setup(props, { emit }) {
    const errors = ref(true)
    const dataModal = ref({
      file_name: {
        id: 'file_name',
        label: 'Tên file',
        placeholder: 'Tên file',
        value: '',
        required: false,
        disable: false,
      },
      table_use: {
        id: 'table_use',
        label: 'Nơi sử dụng',
        placeholder: 'Nơi sử dụng',
        value: '',
        required: false,
        disable: true,
      },
      name: {
        id: 'name',
        label: 'Tên cài đặt',
        placeholder: 'Tên cài đặt',
        value: '',
        required: false,
        disable: false,
        options: []
      },
      type: {
        id: 'type',
        label: 'Kiểu File',
        placeholder: 'Kiểu File',
        value: '',
        required: false,
        disable: true,
      },
    })
    const clickShowModal = ref(false)
    const accountStore = useAccountStore()
    const userDetail = reactive({
      user_id: {
        label: 'ID người dùng',
        value: ''
      },
      display_name: {
        label: 'Tên hiển thị',
        value: ''
      },
      user_alias: {
        label: 'Tên thay thế',
        value: ''
      },
      shared_info:{
        label: 'Thông tin chia sẻ',
        value: ''
      },
      is_sensitive: {
        label: 'Nhóm người dùng',
        value: ''
      },
      user_is_follower: {
        label: 'Trạng thái quan tâm OA',
        value: ''
      },
      user_last_interaction_date: {
        label: 'Ngày cuối tương tác',
        value: ''
      }
  })
    const avatar = ref('')
    const settingFormatFileStore = useSettingFormatFileStore()

    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      clickShowModal.value = eventClickShowModal
      Object.keys(props.user).forEach((item) => {
        if(item === 'user_id') {
          userDetail.user_id.value = props.user?.user_id ?? ''
        }
        if(item === 'user_alias') {
          userDetail.user_alias.value = props.user?.user_alias ?? ''
        }
        if(item === 'shared_info') {
          userDetail.shared_info.value = props.user?.shared_info ?? ''
          if(typeof userDetail.shared_info.value === "object") {
            userDetail.shared_info.value = {
              city: {
                label: 'Thành phố',
                value: ''
              },
              name: {
                label: 'Tên',
                value: ''
              },
              phone: {
                label: 'Số điện thoại',
                value: ''
              },
              address: {
                label: 'Địa chỉ',
                value: ''
              },
              district: {
                label: 'Quận/Huyện',
                value: ''
              },
              user_dob: {
                label: 'Ngày sinh',
                value: ''
              }
            }
            if(props.user?.shared_info?.city) {
              userDetail.shared_info.value.city.value = props.user?.shared_info?.city
            }
            if(props.user?.shared_info?.name) {
              userDetail.shared_info.value.name.value = props.user?.shared_info?.name
            }
            if(props.user?.shared_info?.address) {
              userDetail.shared_info.value.address.value = props.user?.shared_info?.address
            }
            if(props.user?.shared_info?.district) {
              userDetail.shared_info.value.district.value = props.user?.shared_info?.district
            }
            if(props.user?.shared_info?.phone) {
              userDetail.shared_info.value.phone.value = props.user?.shared_info?.phone
            }
            if(props.user?.shared_info?.user_dob) {
              userDetail.shared_info.value.user_dob.value = props.user?.shared_info?.user_dob
            }
          }
        }
        if(item === 'display_name') {
          userDetail.display_name.value = props.user?.display_name ?? ''
        }
        if(item === 'is_sensitive') {
          userDetail.is_sensitive.value = props.user?.is_sensitive ? 'Đủ 18 tuổi trở lên' : 'Dưới 18 tuổi'
        }
        if(item === 'user_is_follower') {
          userDetail.user_is_follower.value = props.user?.user_is_follower ? 'Đang theo dõi' : 'Chưa theo dõi'
        }
        if(item === 'user_last_interaction_date') {
          userDetail.user_last_interaction_date.value = props.user?.user_last_interaction_date ?? ''
        }
      })
      avatar.value = props.user?.avatar ?? ''
      emit('showModal', true)
    })


    watch(() => settingFormatFileStore.settingFormat, (newListSettingFormat) => {
      newListSettingFormat.forEach((item) => {
        dataModal.value.name.options.push({
          name: item.name,
          value: item.id,
        })
      })
    });

    watch(() => dataModal.value.name.value, (newSetting) => {
      const settingSelected = settingFormatFileStore.settingFormat.find(setting => newSetting === setting.id)
      dataModal.value.type.value = CommonService.compareTypeFileLabel(settingSelected.type ?? 0)
    });

    function onChange(value, name) {
      dataModal.value[name].value = value;
    }

    return {
      dataModal,
      userDetail,
      avatar,
      onChange,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modalExport {
  .modal-content {
    background: #ffffff;
  }

  .modal-body {
    .select-form, .input-number {
      width: 172px;
    }
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
